export const ACTION_CONFIRM = 'confirm';

export const ACTION_SIGN_OUT = 'signout';
